<template>
    <v-card>
        <v-form
                ref="password-form"
                lazy-validation
        >
            <v-card-title>
                <v-icon left>mdi-lock</v-icon>
                {{ $t('dialog.form.password' ) }}
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                                v-model="password.old"
                                type="password"
                                :label="$t('form.password.old.label')"
                                :error-messages="oldErrors"
                                :counter="30"
                                required
                                @blur="$v.password.old.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                                v-model="password.new"
                                type="password"
                                :label="$t('form.password.new.label')"
                                :error-messages="newErrors"
                                :counter="30"
                                required
                                @blur="$v.password.new.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                                v-model="password.repeatNew"
                                type="password"
                                :label="$t('form.password.new_repeat.label')"
                                :error-messages="repeatNewErrors"
                                :counter="30"
                                required
                                @blur="$v.password.repeatNew.$touch()"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <br>
                <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
                <v-btn
                        text
                        @click="close"
                >
                    {{ $t('controls.cancel') }}
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                        dark
                        @click="save"
                >
                    {{ $t('controls.save') }}
                </v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
  import { maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
  import { validationMixin } from 'vuelidate'

  export default {
    name: 'UserPasswordForm',
    mixins: [validationMixin],

    validations: {
      password: {
        old: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(30)
        },
        new: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(30)
        },
        repeatNew: {
          required,
          minLength: minLength(8),
          maxLength: maxLength(30),
          sameAsPassword: sameAs('new')
        },
      }
    },

    data: function () {
      return {
        password: {
          old: '',
          new: '',
          repeatNew: ''
        }
      }
    },

    computed: {
      oldErrors () {
        const errors = []
        if (!this.$v.password.old.$dirty) return errors
        !this.$v.password.old.minLength && errors.push(this.$t('form.password.old.min-length'))
        !this.$v.password.old.maxLength && errors.push(this.$t('form.password.old.max-length'))
        !this.$v.password.old.required && errors.push(this.$t('form.password.old.required'))
        return errors
      },

      newErrors () {
        const errors = []
        if (!this.$v.password.new.$dirty) return errors
        !this.$v.password.new.minLength && errors.push(this.$t('form.password.new.min-length'))
        !this.$v.password.new.maxLength && errors.push(this.$t('form.password.new.max-length'))
        !this.$v.password.new.required && errors.push(this.$t('form.password.new.required'))
        return errors
      },

      repeatNewErrors () {
        const errors = []
        if (!this.$v.password.repeatNew.$dirty) return errors
        !this.$v.password.repeatNew.minLength && errors.push(this.$t('form.password.repeat.min-length'))
        !this.$v.password.repeatNew.maxLength && errors.push(this.$t('form.password.repeat.max-length'))
        !this.$v.password.repeatNew.required && errors.push(this.$t('form.password.repeat.required'))
        !this.$v.password.repeatNew.sameAsPassword && errors.push(this.$t('form.password.repeat.same-as'))
        return errors
      },
    },

    methods: {
      save () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$store.dispatch('user/updatePassword', this.password)
            .then(() => {

              this.$store.commit('notification/newNotification', {
                text: this.$t('form.password.updated')
              })

              this.$emit('settingsIsProcessed')
              this.reset()
            })
        }
      },

      close () {
        this.$emit('settingsIsCanceled')
        this.reset()
      },

      reset () {
        this.$refs['password-form'].reset()
        this.$v.$reset()
      }
    }
  }
</script>

<style scoped>

</style>
